import 'slick-carousel';
import 'slick-lightbox';

import AOS from 'aos';
AOS.init( {
    disable: 'mobile',
    once: true,
    duration: 500,
    anchorPlacement: 'top-bottom',
} );

// global
import './global/global.js';
import './global/modal.js';
import './global/header.js';

import './web-components/accordion-item.js';

/**
 * Template Parts
 */
import './template-parts/accordion.js';
import './template-parts/single-post.js';
import './template-parts/slider.js';
import './template-parts/dialog.js';

/**
 * Blocks
 */
import "../../blocks/accordion-cards-slider/accordion-cards-slider.js";
import "../../blocks/accreditations/accreditations.js";
import "../../blocks/big-slider/big-slider.js";
import "../../blocks/blog-listing/blog-listing.js";
import "../../blocks/case-study-slider/case-study-slider.js";
import "../../blocks/gallery/gallery.js";
import "../../blocks/hero-banner/hero-banner.js";
import "../../blocks/icons/icons.js";
import "../../blocks/image-and-content-slider/image-and-content-slider.js";
import "../../blocks/staggered-content/staggered-content.js";
import "../../blocks/tabs/tabs.js";
import "../../blocks/testimonials/testimonials.js";
import "../../blocks/collage-grid/collage-grid.js";
import "../../blocks/auto-slider/auto-slider.js";
import "../../blocks/map/map.js";
